import clsx from 'clsx'
import { useEffect, useRef, useState } from 'react'
import { adjustTextSize } from 'utils'

import mainStyles from 'assets/css/main.module.scss'
import Bubble from 'components/bubble/Bubble'
import QuestionItem from 'components/QuestionItem'
import { QUESTIONS } from 'constants/questions'

import styles from './App.module.scss'

export function App() {
  const containerRef = useRef<HTMLDivElement>(null)
  const textRef = useRef<HTMLDivElement>(null)
  const [activeIndex, setActiveIndex] = useState<number | null>(null)

  useEffect(() => {
    setTimeout(() => adjustTextSize(containerRef.current, textRef.current, 170), 50)

    // Adjust text size on window resize to maintain responsiveness
    window.addEventListener('resize', () => adjustTextSize(containerRef.current, textRef.current, 170))
    return () => {
      window.removeEventListener('resize', () => adjustTextSize(containerRef!.current, textRef!.current, 170))
    }
  }, [])

  return (
    <div>
      <div className={clsx(styles.containerText)} ref={containerRef}>
        <div ref={textRef} className={styles.weirdHeader}>
          INTERCOM KNOWS
        </div>
      </div>
      <div className="group bg-[linear-gradient(180deg,_#680101_0%,_#F40000_100%)]">
        <div className="py-24 px-40">
          <div className={clsx(mainStyles.white8XL, '-mt-3 z-1 relative')}>
            So long FAQs,
            <br />
            <span>Hello </span>
            <span className="inline-flex relative flex-col">
              <Bubble
                text="Find it on Intercom!"
                color="#EBFF00"
                className="text-[#003735] hidden group-hover:block left-auto -right-48 -top-8"
              />
              Intercom
              <svg width="376" height="14" viewBox="0 0 376 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2 4.98047C65.6588 10.407 129.863 12.5323 194.271 10.7917C243.386 9.46441 292.482 6.36499 341.541 3.24018C352.872 2.51843 362.55 2.17504 373.373 3.65012"
                  stroke="#EBFF00"
                  strokeWidth="4"
                  strokeLinecap="round"
                />
              </svg>
            </span>
          </div>
          <div className="mt-8">
            <div className={clsx(mainStyles.whiteSStrong, 'max-w-[650px]')}>
              Yeah, kinda old school. No worries, we have a solve… the mighty Intercom chat! Your super high tech,
              AI-powered, human-backed support resource. Simply pop your ? into Intercom! See if Intercom has a
              real-time answer, if not, we'll have a human come back to you. Still hunger for some FAQs? Fine. Here's a
              few. We aim to please.
            </div>
          </div>
        </div>
        <div className={clsx('absolute left-auto right-16 top-64')}>
          <svg
            className={clsx('transform rotate-[4deg] overflow-visible')}
            width="374"
            height="457"
            viewBox="0 0 374 457"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
                <feDropShadow dx="46" dy="51" stdDeviation="34.5" floodColor="rgba(148, 148, 148, 0.09)" />
                <feDropShadow dx="104" dy="115" stdDeviation="46.5" floodColor="rgba(148, 148, 148, 0.05)" />
                <feDropShadow dx="185" dy="205" stdDeviation="55.5" floodColor="rgba(148, 148, 148, 0.01)" />
                <feDropShadow dx="289" dy="321" stdDeviation="60.5" floodColor="rgba(148, 148, 148, 0.00)" />
              </filter>
            </defs>
            <path
              filter="url(#shadow)"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M35 0C15.67 0 0 15.6701 0 35L0 368.293C0 387.623 15.67 403.293 35 403.293H287.773L357.544 454.239C364.211 459.108 373.572 454.257 373.439 446.003L372.754 403.293H373.012V35C373.012 15.67 357.342 0 338.012 0L35 0Z"
              fill="white"
            />
            <path
              d="M312.962 275.439C316.132 277.842 316.767 282.371 314.229 285.435C299.567 303.135 281.367 317.615 260.768 327.93C238.02 339.321 212.956 345.326 187.516 345.481C162.076 345.637 136.941 339.937 114.055 328.825C93.3324 318.762 74.9571 304.504 60.0795 286.985C57.5044 283.952 58.0841 279.416 61.2254 276.975C64.3667 274.534 68.8792 275.114 71.4668 278.136C84.9799 293.916 101.613 306.768 120.348 315.865C141.246 326.013 164.198 331.217 187.428 331.075C210.659 330.934 233.545 325.45 254.318 315.048C272.94 305.723 289.415 292.669 302.735 276.725C305.286 273.672 309.791 273.037 312.962 275.439Z"
              fill="#F40000"
            />
          </svg>
        </div>
      </div>
      <div className={clsx('absolute left-44 top-[457px] hover:cursor-pointer')}>
        <div className="group rounded-tl-[48px] rounded-tr-[48px] rounded-br-[48px] bg-[#EBFF00] hover:bg-[#003735] hover:text-[#EBFF00] px-[36px] py-[22px] -rotate-[4.6deg]">
          <div
            className={clsx(
              mainStyles.darkGreenBold,
              'group-hover:text-[#EBFF00] group-hover:text-[42px] w-[550px] text-center group-hover:w-[600px] transform ease-in-out transition-all duration-300',
            )}
          >
            What is The Playground?
          </div>
        </div>
      </div>
      <div className="flex flex-row items-start justify-center w-full mt-32">
        <div className={clsx('px-40 py-24 space-y-4 w-full', styles.containerBody)}>
          {QUESTIONS.map((item, index) => (
            <QuestionItem
              key={item.question}
              question={item.question}
              answer={item.answer}
              icon={item.icon}
              alt={item.alt}
              isOpen={activeIndex === index}
              onToggle={() => setActiveIndex(activeIndex === index ? null : index)}
              isLast={index === QUESTIONS.length - 1}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
